import Guidance from './Guidance';
import ReleaseNotes from './ReleaseNotes';

function AdditionalResources() {
  return (
    <>
      <hr aria-hidden="true" />
      <div
        className="landing-page__links-container"
        aria-label="Additional resources"
      >
        <ReleaseNotes />
        <div className="landing-page__divider" aria-hidden="true" />
        <Guidance />
      </div>
    </>
  );
}

export default AdditionalResources;
